import { Card } from '@qrkey/ui';
import { Link } from '@tanstack/react-router';
import type { ReactNode } from 'react';

/** Centered card for sign-in screens, with the product mark and an Appearance link. */
export function AuthLayout({
  title,
  description,
  children,
  wide = false,
}: {
  title: string;
  description?: ReactNode;
  children: ReactNode;
  wide?: boolean;
}) {
  return (
    <div className="auth">
      <header className="auth__brand">
        <span className="brand-mark" aria-hidden="true">
          Q
        </span>
        <span className="auth__product">QRkey</span>
      </header>
      <main id="main" className={wide ? 'auth__main auth__main--wide' : 'auth__main'}>
        <Card title={title} titleLevel={1} description={description} padding="lg">
          {children}
        </Card>
      </main>
      <footer className="auth__footer">
        <Link to="/appearance" className="auth__footer-link">
          Appearance
        </Link>
      </footer>
    </div>
  );
}
